import { useParams } from "react-router-dom";
import ContributionNavbar from "./ContributionNavbar";
import { useEffect, useState } from "react";
import { getGroupInfo } from "../../api";
import GroupInfoSection from "./groupInfo";
import Footer from "./ContributionFooter";
import USSDContributionSection from "./USSDContribution";
import CardMomoContribution from "./CardMomoContribution";
import ErrorPage from "../errorPage";

const CrowdfundContributionPage = () => {
  const { token } = useParams();
  const { groupInfo, isLoading, error } = useGroupInfo(token);

  if (isLoading) return <Loader />;
  if (error) return <ErrorPage />;

  return (
    <div className="bg-white dark:bg-defaultBlack dark:text-white">
      <ContributionNavbar />
      <div className="pt-16 px-4 sm:px-6 lg:px-8">
        <div className="m-10 mx-auto container lg:max-w-full md:border border-[#DEE2E7] dark:border-[#3D404B] rounded-md  flex flex-col lg:flex-row py-4 px-4 gap-10 lg:gap-20">
          {/* group info  */}
          <GroupInfoSection groupInfo={groupInfo} />
          {/* contribution section */}
          <div className="lg:w-1/2">
            <USSDContributionSection groupId={groupInfo?.groupId} />
            {/* visa and momo */}
            <CardMomoContribution token={token} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CrowdfundContributionPage;

const useGroupInfo = (token) => {
  const [groupInfo, setGroupInfo] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGroupDetails = async () => {
      setError(null);
      try {
        const groupInfo = await getGroupInfo(token);
        setGroupInfo(groupInfo);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchGroupDetails();
  }, [token]);

  return { groupInfo, isLoading, error };
};

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-white dark:bg-defaultBlack dark:text-white">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-gray-700 dark:border-gray-500"></div>
    </div>
  );
};
